import { Box, ToggleButton, ToggleButtonGroup, Tooltip, Typography, useTheme } from "@mui/material";
import { CalendarMonth, TableRows } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { dashboardToggleButtonGroupSx } from "../../Dashboard/dashboard-toggle-button-group.styles";

export enum ScheduleViewMode {
  Calendar = "calendar",
  Table = "table"
}

type P = {
  scheduleViewMode: ScheduleViewMode;
  setScheduleViewMode: (mode: ScheduleViewMode) => void;
};

export function ScheduleViewToggle({ scheduleViewMode, setScheduleViewMode }: Readonly<P>) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ToggleButtonGroup
      value={scheduleViewMode}
      exclusive
      size="small"
      color="primary"
      onChange={(_, value: ScheduleViewMode | null) => value && setScheduleViewMode(value)}
      data-testid="schedule-view-toggle"
      sx={dashboardToggleButtonGroupSx(theme)}
    >
      <ToggleButton value={ScheduleViewMode.Calendar} data-testid="schedule-view-calendar">
        <Tooltip title={<Typography>{t("_scheduleViewCalendar")}</Typography>}>
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
            <CalendarMonth sx={{ fontSize: 32 }} />
          </Box>
        </Tooltip>
      </ToggleButton>

      <ToggleButton value={ScheduleViewMode.Table} data-testid="schedule-view-table">
        <Tooltip title={<Typography>{t("_scheduleViewTable")}</Typography>}>
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
            <TableRows sx={{ fontSize: 32 }} />
          </Box>
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
